import "./Loading.css";

const LoaderBalls = () => (
    <div className="dots">
        <div></div>
        <div></div>
        <div></div>
    </div>
);

export default LoaderBalls;
